import PageHeader from '../layout/PageHeader'
import GroupIcon from '@mui/icons-material/Group'
import PageContainer from '../layout/PageContainer'
import WithFilters from '../../hocs/WithFilters'
import DataInputs from '../dataTable/DataInputs'
import { useSelector } from 'react-redux'
import {
  Card,
  CardContent,
  Button,
  CardHeader,
  // Typography,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import DataTable from '../dataTable/DataTable'
import StoreKeyProvider from '../../providers/StoreKeyProvider'
import makeStyles from '@mui/styles/makeStyles'
import { useDispatch } from 'react-redux'
import { openPopup } from '../../../store/popupsSlice'
import { useEffect, useState } from 'react'
import axios from 'axios'
import ParentCell from '../dataTable/cells/ParentCell'

const useStyles = makeStyles(() => ({
  mainPatients: {
    // height: 'calc(100% - 64px)',
  },
}))

const Home = () => {
  const user = useSelector((state) => state.user.user)
  const dispatch = useDispatch()
  const classes = useStyles()

  const [genders, setGenders] = useState([])

  useEffect(() => {
    axios.post('/lookups/genders', null).then((res) => {
      setGenders(res.data)
    })
  }, [])

  return (
    <div className={classes.mainPatients}>
      <PageHeader
        icon={<GroupIcon fontSize="large" />}
        title="Pacjenci"
        subtitle="Tutaj znajdziesz listę Twoich pacjentów"
      />
      <PageContainer>
        <StoreKeyProvider storeKey="PatientsKey">
          <WithFilters
            config={{
              page: 1,
              paginate: 10,
              orderType: 'desc',
              order: 'created_at',
              inputs: {
                pesel: {
                  value: '',
                  relation: 'LIKE',
                },
                firstname: {
                  values: '',
                  relation: 'LIKE',
                },
                lastname: {
                  value: '',
                  relation: 'LIKE',
                },
                gender_id: {
                  value: null,
                  relation: 'WHERE',
                },
                medical_care_id: {
                  value: null,
                  relation: 'WHERE',
                },
                min_birth_date: {
                  value: null,
                  relation: 'MIN',
                },
                max_birth_date: {
                  value: null,
                  relation: 'MAX',
                },
                phone_number: {
                  value: null,
                  relation: 'LIKE',
                },
                email: {
                  value: null,
                  relation: 'LIKE',
                },
                parent_name: {
                  value: null,
                  relation: 'LIKE',
                },
                min_created_at: {
                  value: null,
                  relation: 'MIN',
                },
                max_created_at: {
                  value: null,
                  relation: 'MAX',
                },
              },
            }}
            endpoint="/patients"
          >
            <Card elevation={2} square>
              <CardHeader
                title="Lista pacjentów"
                action={
                  user && user.role_id == 1 ? (
                    <Button
                      startIcon={<AddIcon />}
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        dispatch(
                          openPopup({
                            component: 'PatientFactory',
                            title: 'Dodaj pacjenta',
                            level: 1,
                            key: 'patient-factory-popup',
                            maxWidth: 'sm',
                          })
                        )
                      }
                    >
                      Dodaj
                    </Button>
                  ) : null
                }
              />
              <CardContent>
                {genders && (
                  <DataInputs
                    inputs={[
                      {
                        id: 'pesel',
                        label: 'PESEL',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'firstname',
                        label: 'Imię',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'lastname',
                        label: 'Nazwisko',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'gender_id',
                        label: 'Płeć',
                        placeholder: '',
                        type: 'select',
                        options: genders,
                      },
                      {
                        id: 'birth_date',
                        label: 'Data ur.',
                        placeholder: '',
                        type: 'date-between',
                      },
                      {
                        id: 'phone_number',
                        label: 'Nr. Tel.',
                        placeholder: '',
                        type: 'tel',
                      },
                      {
                        id: 'email',
                        label: 'E-mail',
                        placeholder: '',
                        type: 'text',
                      },
                      {
                        id: 'parent_name',
                        label: 'Rodzic',
                        placeholder: '',
                        type: 'text',
                      },
                    ]}
                  />
                )}
                <DataTable
                  breakpoint={1583}
                  actions="PatientsTableActions"
                  labels={[
                    'PESEL',
                    'Imię',
                    'Nazwisko',
                    'Płeć',
                    'Data ur.',
                    'Data dodania',
                    'Nr. Tel.',
                    'E-mail',
                    'Rodzic',
                  ]}
                  keys={[
                    'pesel',
                    'firstname',
                    'lastname',
                    'gender_name',
                    'birth_date',
                    'created_at',
                    'phone_number',
                    'email',
                    'parent_name',
                  ]}
                  rowComponents={{
                    parent_name: ParentCell,
                  }}
                />
              </CardContent>
            </Card>
          </WithFilters>
        </StoreKeyProvider>
      </PageContainer>
    </div>
  )
}

export default Home
